module.exports = __webpack_public_path__ + "static/media/G_Ex_icon.7753dbc0.png";